import { Link } from '@/components';
import {
  ArrowRightIcon,
  Box,
  Card,
  CardProps,
  Flex,
  FlexProps,
  KpiBody,
  KpiFooter,
  KpiHeader
} from '@blockanalitica/ui';
import { ReactNode } from 'react';
import styled from 'styled-components';

const Content = styled(Flex)<FlexProps>``;

const Arrow = styled(ArrowRightIcon)`
  dispay: flex;
  align-self: flex-end;
  color: ${(props) => props.theme.colors.muted};
`;

const StyledLink = styled(Link)`
  color: inherit;
  display: flex;
  flex: 1;

  & ${Content}, & :after {
    transition: 0.25s ease-out;
  }

  &:hover {
    color: inherit;

    & ${Content}, & :after {
      scale: 1.02;
    }

    & ${Arrow} {
      color: ${(props) => props.theme.colors.linkHover};
    }
  }
`;

const StyledFlexExtra = styled(Flex)`
  justify-content: flex-end;
  opacity: 0.4;
`;

export interface KpiCardProps extends Omit<CardProps, 'title'> {
  title: ReactNode;
  value?: ReactNode;
  linkTo?: string;
  trendValue?: ReactNode;
  footer?: ReactNode;
  extra?: ReactNode;
}

function Wrapper({
  linkTo,
  children
}: {
  linkTo?: string;
  children: ReactNode;
}) {
  if (linkTo) {
    return <StyledLink to={linkTo}>{children}</StyledLink>;
  }
  return <>{children}</>;
}

export default function KpiMultiCard({
  title,
  value,
  trendValue,
  footer,
  extra,
  linkTo,
  ...rest
}: KpiCardProps) {
  return (
    <Wrapper linkTo={linkTo}>
      <Card {...rest} display="flex" flex="1">
        <Content gap="xs" flexDirection="column" flex="1">
          <KpiHeader>{title}</KpiHeader>
          <Flex flexDirection="row" flex="1">
            <Flex flexDirection="column" gap="xs" flex="1">
              <KpiBody
                gap="s"
                alignItems="center"
                justifyContent="space-between">
                <Flex alignItems="baseline" gap="xs" width="100%" fontSize="4">
                  {value}
                  {trendValue ? <Box fontSize="1">{trendValue}</Box> : null}
                </Flex>
                {extra ? <StyledFlexExtra>{extra}</StyledFlexExtra> : null}
              </KpiBody>
              {footer ? <KpiFooter>{footer}</KpiFooter> : null}
            </Flex>
            {linkTo !== undefined ? <Arrow size="2" /> : null}
          </Flex>
        </Content>
      </Card>
    </Wrapper>
  );
}
